import React, { useState } from 'react';
import './Login.css'
import axios from 'axios';
import config from '../config';

const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Simple validation
    if (!username || !password) {
      setError('Both fields are required');
      setLoading(false);
      return;
    }

    try {
      const apiUrl = `${config.apiUrl}/login`;
      console.log('Login attempt details:', {
        url: apiUrl,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      // Create axios instance with default config
      const axiosInstance = axios.create({
        baseURL: config.apiUrl,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: true
      });

      // Log the request configuration
      console.log('Request configuration:', {
        url: apiUrl,
        method: 'POST',
        data: { email: username, password: password },
        headers: axiosInstance.defaults.headers
      });

      // Send the request
      const response = await axiosInstance.post('/login', {
        email: username,
        password: password
      });

      console.log('Login response:', response.data);

      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        setError('');
        window.location.href = '/dashboard';
      } else {
        setError('Invalid response from server');
      }
    } catch (err) {
      console.error('Login error details:', {
        message: err.message,
        response: err.response ? {
          status: err.response.status,
          data: err.response.data,
          headers: err.response.headers
        } : 'No response',
        request: err.request ? 'Request was made but no response received' : 'No request was made'
      });

      if (err.response) {
        setError(err.response.data?.message || 'Server error occurred');
      } else if (err.request) {
        setError('No response from server. Please check your connection.');
      } else {
        setError('Failed to login. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="login-container">
      {/* Login Form */}
      <div className="login-form">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              disabled={loading}
            />
          </div>

          {error && <p className="error">{error}</p>}

          <button type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
